import BaseClient from './BaseClient';

class AdminUsersClient extends BaseClient {
    showUser(userId) {
        const url = `/api/admin/users/${userId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    listUserTeams(userId, params) {
        const url = `/api/admin/users/${userId}/teams`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    listUsers(params) {
        const url = `/api/admin/users`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    favoriteUser(userId) {
        const url = `/api/admin/users/${userId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteFavoriteUser(userId) {
        const url = `/api/admin/users/${userId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminUsersClient();
